import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import LoginScreen from "./Pages/LoginScreen";
import Dashboard from "./Pages/Dashboard";
import HomeScreen from "./Pages/HomeScreen";
import Onsite from "./Pages/Onsite";
import AnnisiteDetails from "./Pages/AnnisiteDetails";
import UserList from "./Pages/UserList";
import UserDetails from "./Pages/UserDetails";
import Annisite from "./Pages/Annisite";
import Settings from "./Pages/Settings";

function App() {
  return (
     <>
     <Router>
        <div className="main-container">
          <Routes>              
             <Route path="/login" element={<LoginScreen />}/>  
 
             <Route element={<Dashboard />}>
                 <Route path="/" element={<HomeScreen/>}/> 
                 <Route path="/dashboard" element={<HomeScreen/>}/> 
                 <Route path="/onsites" element={<Onsite/>}/>  
                 <Route path="/annisites" element={<Annisite/>}/>  
                 <Route path="/annisite-details/:id" element={<AnnisiteDetails/>}/>
                 <Route path="/users" element={<UserList />}/>
                 <Route path="/user-details/:id" element={<UserDetails />}/>
                 <Route path="/settings" element={<Settings />}/>
             </Route>
          </Routes>
        </div>
     </Router>
     <ToastContainer />
    </>
  );
}

export default App;
